import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import CustodianRoutes from '../../Component/Layouts/IndCustodianLayout';


const mdTheme = createTheme();

function MainCustodian() {

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Custodian Performance"/>
        <CustodianRoutes/>
      </Box>
    </ThemeProvider>
  );
}

export default function CustodianManagement() {
  return <MainCustodian />
}